import { Button, IconSparkleFilled, IconWhatsappFilled } from "takeat-design-system-ui-kit";
import React, { useEffect, useState } from "react";
import { useAuth } from "~/context/AuthContext";
import { WaiterPosComponent } from "./styles";

import image from '../../assets/img/posMachines.svg';
import logo from '../../assets/img/takeatWhiteLogo.svg';

const key = "@gddashboard:waiterPos";
export const keyWaiterPos = "@gddashboard:waiterPos:keyLogin";

function handleModalFlow(
  isCloseWaiterPos,
  isCheckedWaiterPos
) {
  if (isCheckedWaiterPos && isCloseWaiterPos) {
    return true;
  } else if (!isCheckedWaiterPos && isCloseWaiterPos) {
    return true;
  } else if (isCheckedWaiterPos && !isCloseWaiterPos) {
    return true;
  } else if (!isCheckedWaiterPos && !isCloseWaiterPos) {
    return false;
  } else {
    return true;
  }
}

export default function WaiterPos() {
  const { user } = useAuth();

  const [isCheckedWaiterPos, setIsCheckedWaiterPos] = useState(() => {
    const storagedValue = localStorage.getItem(key) === 'true';
    return !!storagedValue;
  });

  useEffect(() => {
    const storagedValue = localStorage.getItem(key);

    if (isCheckedWaiterPos && !storagedValue) {
      localStorage.setItem(key, true);
    }
  }, [isCheckedWaiterPos]);

  const [isCloseWaiterPos, setIsCloseWaiterPos] = useState(() => {
    const storagedValue = localStorage.getItem(keyWaiterPos) === 'true';
    return !!storagedValue;
  });

  useEffect(() => {
    const storagedValue = localStorage.getItem(keyWaiterPos) === 'true';

    if (isCheckedWaiterPos && !storagedValue) {
      localStorage.setItem(keyWaiterPos, true);
    }
  }, [isCheckedWaiterPos]);

  function handleCloseWaiterPos() {
    setIsCloseWaiterPos(true);
    localStorage.setItem(keyWaiterPos, true);
  }

  function handleWhatsappWaiterPos() {
    setIsCheckedWaiterPos(true);

    const message = "Olá, gostaria de saber mais sobre integrações com máquina POS";
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/5527998338296?text=${encodedMessage}`;

    window.open(url, "_blank");
    handleCloseWaiterPos();
  }

  const modalFlow = handleModalFlow(
    isCloseWaiterPos,
    isCheckedWaiterPos
  );
  
  const open = !modalFlow && !["/login", "/login/", "", "/"].includes(window.location.pathname || '') && user?.use_smart_pos;

  return <WaiterPosComponent
    open={open}
    toggle={() => {
      setIsCloseWaiterPos(true);
      localStorage.setItem(keyWaiterPos, true);
    }}
  > 
    <header>
      <img src={logo} width={83} height={24} />
    </header>
    <div>
      <img src={image} alt="" />
      <span>Garçom na maquininha? É possível!</span>
      <span>Já pensou em usar o App do Garçom diretamente na maquininha de cartão e eliminar erros nos lançamentos de vendas?</span>
      <section>
        <IconSparkleFilled
          fill="#c8131b"
          fontSize={22}
        />
        Além disso, aumente a rotatividade do seu salão e eleve seus lucros!
      </section>
      <div>
        <IconWhatsappFilled
          fill="#c8131b"
          fontSize={22}
        />
        Fale com a{' '}
        <span style={{ fontWeight: 700 }}>Adriele</span>
        {' '}e garanta essa integração agora mesmo!
      </div>
      <Button onClick={handleWhatsappWaiterPos}>Entrar em contato</Button>
      <p>Integrações disponíveis: Rede, Getnet, Stone, Ifood, Pagbank, Picpay</p>
    </div>
  </WaiterPosComponent>
}